// Placeholder logo imports (replace with actual logo imports as needed)
import React from 'react';
import { motion } from 'framer-motion';

const logos = [
  // Real company logos
'./Logos/Kohinoor.png',
'./Logos/Unique Group.png',
'./Logos/Triaa.png',
'./Logos/Saheel Properties.png',
'./Logos/Tayal corp.jpg.jpeg',
'./Logos/Jhamtani.jpg.jpeg',
'./Logos/Ranawat Group.png',
'./Logos/Oree Reality.png',
'./Logos/Chandrarang.png',
'./Logos/Skyi.jpg.jpeg',
'./Logos/Goel Ganga Development.png',
'./Logos/DPU.png',
'./Logos/Fidesto.jpg.jpeg',
'./Logos/Shriram Properties.jpg.jpeg',
'./Logos/City One.jpg.jpeg',
'./Logos/GKG Venture.jpg.jpeg',
'./Logos/Namrata Group.png',
'./Logos/Miracle Developers.jpg.jpeg',
'./Logos/Vighnharta.jpg.jpeg',
'./Logos/Shubh Developers.jpg.jpeg',
'./Logos/Naiknaware.png',
'./Logos/Raviraj.jpg.jpeg',
'./Logos/Aswani.png',
'./Logos/Kiran Creators.png',  
'./Logos/Reliance.png',
'./Logos/Toyota.png',
'./Logos/Skoda.png',
'./Logos/Honda.png',
'./Logos/Urway Group.png',
'./Logos/Kumar Realty.jpg.jpeg',
'./Logos/Oxy Buildcorp.jpg.jpeg',
'./Logos/Achalare Realtors.png',
'./Logos/Prism City.jpg.jpeg',
'./Logos/Marvel Realtors.png',
'./Logos/Profile Group.png',
'./Logos/Amegh Properties.png',
'./Logos/Krisala.png',

  // 20 placeholders for demonstration
  // ...Array.from({ length: 20 }, (_, i) => `https://via.placeholder.com/100x60?text=Logo+${i+39}`),
];

const Vendors = ({ noMargin }) => (
  <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 flex flex-col items-center justify-start py-10" style={noMargin ? undefined : { marginTop: "90px" }}>
    <h1 className="text-3xl md:text-4xl font-bold text-white text-center font-sans mb-8">Vendors</h1>
    <div className="w-11/12 max-w-6xl flex flex-col">
      <div className="mb-6">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-left font-sans">Clients</h2>
      </div>
      <motion.div
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-y-8 gap-x-12 justify-items-center items-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={{
          visible: { transition: { staggerChildren: 0.08 } },
          hidden: {}
        }}
      >
        {logos.map((logo, idx) => (
          <motion.div
            key={idx}
            className={
              `bg-black rounded-xl p-4 flex items-center justify-center shadow-sm hover:shadow-lg transition-shadow duration-300`
            }
            variants={{
              hidden: { opacity: 0, y: 40 },
              visible: { opacity: 1, y: 0, transition: { type: 'spring', stiffness: 60, damping: 18, duration: 0.7 } }
            }}
          >
            <div className="bg-black rounded-lg p-3 flex items-center justify-center w-[120px] h-[72px]">
              <img
                src={logo}
                alt={`Vendor logo ${idx + 1}`}
                className="max-w-[105px] max-h-[60px] object-contain drop-shadow-lg transition-transform duration-300 hover:scale-105"
              />
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
    <div className="w-11/12 max-w-6xl mt-12">
      <h2 className="text-2xl md:text-3xl font-bold text-white text-left font-sans mb-6">Architects</h2>
      <motion.div
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-y-8 gap-x-12 justify-items-start items-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={{
          visible: { transition: { staggerChildren: 0.08 } },
          hidden: {}
        }}
      >
        {[
          './Logos/Planedge.png',
          './Logos/Vka Architects.jpg.jpeg',
          './Logos/Landmark Architects Design.jpg.jpeg',
          './Logos/Design 11.jpg.jpeg',
          './Logos/WK Architects.png',
          './Logos/IP Associates.jpg.jpeg',
          './Logos/Space Craft.jpg.jpeg',
          './Logos/Ankur Associates.jpg.jpeg',
          './Logos/Samyak.jpg.jpeg',
          './Logos/Cubix Architects.jpg.jpeg',
        ].map((img, idx) => (
          <motion.div
            className="bg-black rounded-xl p-4 flex items-center justify-center shadow-sm hover:shadow-lg transition-shadow duration-300"
            key={idx}
            variants={{
              hidden: { opacity: 0, y: 40 },
              visible: { opacity: 1, y: 0, transition: { type: 'spring', stiffness: 60, damping: 18, duration: 0.7 } }
            }}
          >
            <div className="bg-black rounded-lg p-3 flex items-center justify-center w-[120px] h-[72px]">
              <img
                src={img}
                alt={`Architect block ${idx + 1}`}
                className="max-w-[105px] max-h-[60px] object-contain drop-shadow-lg"
              />
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </div>
);

export default Vendors;
